// TextoArqueadoVertical.js 
import React, { useRef, useState, useMemo, useEffect, forwardRef, useImperativeHandle } from "react";
import * as THREE from "three";
import { Canvas, useFrame, useThree } from "@react-three/fiber";
import { OrbitControls, Html } from "@react-three/drei";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader";
import SuperVanilla from "../../../fonts/Super Vanilla_Regular.json";
import SpookyCartoon from "../../../fonts/Spooky Cartoon_Regular.json";
import KindDaily from "../../../fonts/Kind Daily_Regular.json";
import CandyBeans from "../../../fonts/Candy Beans_Regular.json";
import LastShuriken from "../../../fonts/The Last Shuriken_Regular.json";
import TransformersMovie from "../../../fonts/Transformers Movie_Regular.json";
import ZombieZone from "../../../fonts/Zombie Zone_Regular.json";
import ToastyMilk from "../../../fonts/Toasty Milk_Regular.json";
import Karate from "../../../fonts/Karate_Medium.json";
import SimplyRounded from "../../../fonts/Simply_Rounded_Bold.json";
import HaloDek from "../../../fonts/Halo Dek_Regular.json";
import SundayMidnight from "../../../fonts/Sunday Midnight_Regular.json";

// === NUEVAS FUENTES ===
import LovelyHeart from "../../../fonts/LOVELY HEART_Regular.json";
import MeowInLove from "../../../fonts/Meow in Love Demo_Regular.json";
import MaximumVoltage from "../../../fonts/Maximum Voltage_Regular.json";
import MaximumVoltageItalic from "../../../fonts/Maximum Voltage_Italic.json";
import VampireWars from "../../../fonts/Vampire Wars_Regular.json";
import VampireWarsItalic from "../../../fonts/Vampire Wars_Italic.json";
import Gimbot from "../../../fonts/Gimbot_Regular.json";
import BillyBounce from "../../../fonts/Billy Bounce_Regular.json";
import BlackCastleMF from "../../../fonts/BlackCastleMF_Regular.json";
import CandyShop from "../../../fonts/Candy Shop_Regular.json";
import CandyShopBlack from "../../../fonts/Candy Shop Black_Regular.json";
import AngryBirds from "../../../fonts/AngryBirds_Regular.json";
import Tomcat from "../../../fonts/Tomcat_Regular.json";
import Comicoon from "../../../fonts/Comicoon_Regular.json";
import Grinched from "../../../fonts/Grinched_Regular.json";
import Kraash from "../../../fonts/Kraash_Regular.json";
import KraashBlack from "../../../fonts/Kraash Black_Regular.json";
import Powerful from "../../../fonts/Powerful_Regular.json";
import MilkyNice from "../../../fonts/Milky Nice_Regular.json";
import MilkyNiceClean from "../../../fonts/Milky Nice Clean_Regular.json";
import SuperMario256 from "../../../fonts/Super Mario 256_Regular.json";
import Dinosaur from "../../../fonts/Dinosaur_Regular.json";
import SealightWhisper from "../../../fonts/Sealight Whisper_Regular.json";
import Yourmate from "../../../fonts/Yourmate_Regular.json";
import BubbleGum from "../../../fonts/BubbleGum_Regular.json";
import MagicSound from "../../../fonts/Magic Sound_Regular.json";
import Bestime from "../../../fonts/Bestime_Regular.json";
import SuperBoys from "../../../fonts/Super Boys_Regular.json";
import MilkshakeCreps from "../../../fonts/Milkshake Creps_Regular.json";
import GrindAndDeath from "../../../fonts/GrindAndDeath_Demo_Regular.json";
import GodOfWar from "../../../fonts/GodOfWar_Regular.json";
import Dynamix from "../../../fonts/Dynamix_Regular.json";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { STLExporter } from "three/examples/jsm/exporters/STLExporter.js";

export default function TextoArqueadoVertical() {
  const [texto, setTexto] = useState("3D Fyrion");
  const [fuenteSeleccionada, setFuenteSeleccionada] = useState("Super Vanilla");
  const [autoRotar, setAutoRotar] = useState(false);
  const [rotacion, setRotacion] = useState({
    x: THREE.MathUtils.degToRad(-90),
    y: 0,
    z: THREE.MathUtils.degToRad(180),
  });
  const [posicion, setPosicion] = useState({ x: 0, y: 0, z: 0 });
  const [zoom, setZoom] = useState(80);
  const [radio, setRadio] = useState(8);

  // === MODELO 2 ===
  const [texto2, setTexto2] = useState("Texto 2");
  const [fuente2, setFuente2] = useState("Super Vanilla");
  const [rot2, setRot2] = useState({
    x: THREE.MathUtils.degToRad(-90),
    y: 0,
    z: THREE.MathUtils.degToRad(180),
  });
  const [radio2, setRadio2] = useState(5);

  // === MODELO 3 ===
  const [texto3, setTexto3] = useState("Texto 3");
  const [fuente3, setFuente3] = useState("Super Vanilla");
  const [rot3, setRot3] = useState({
    x: THREE.MathUtils.degToRad(-90),
    y: 0,
    z: THREE.MathUtils.degToRad(180),
  });
  const [radio3, setRadio3] = useState(1);

  const scaleFactor = window.innerWidth < 768 ? 0.8 : 1; // móviles un poco más compactos
  const [pos2, setPos2] = useState({ x: 0, y: -1.5 * scaleFactor, z: 3 * scaleFactor });
  const [pos3, setPos3] = useState({ x: 0, y: -3.2 * scaleFactor, z: 6 * scaleFactor });

  // --- Base ---
  // Mostrar base por defecto en true para "forzar" que aparezca siempre
  const [mostrarBase, setMostrarBase] = useState(true);
  const [tipoBase, setTipoBase] = useState("normal");
  const [posBase, setPosBase] = useState({ x: 0, y: 15, z: -6 });
  const [rotBase, setRotBase] = useState({ x: THREE.MathUtils.degToRad(-90), y: 0, z: 0 });
  const [groupScale, setGroupScale] = useState(1);

  // Qué modelo está seleccionado para mover/rotar
  const [modeloActivo, setModeloActivo] = useState(1);


  ////
  // 🎨 Colores individuales y generales
const [colorTexto1, setColorTexto1] = useState("#00ccff");
const [colorTexto2, setColorTexto2] = useState("#ff00ff");
const [colorTexto3, setColorTexto3] = useState("#ffaa00");
const [colorBase, setColorBase] = useState("#0066aa");

// ✅ Color general y activación global
const [colorGeneral, setColorGeneral] = useState("#ffffff");
const [usarColorGeneral, setUsarColorGeneral] = useState(false);

/////////////////////////////////////////////////////////
const [cargado, setCargado] = useState(false);


const [modeloIzquierda, setModeloIzquierda] = useState(null);
const [modeloDerecha, setModeloDerecha] = useState(null);

const [centrosBase, setCentrosBase] = useState(null);

// === Control dinámico del offset de BaseAutomatica según cantidad de textos llenos ===
const [offsetY, setOffsetY] = useState(2);

// <<< NUEVO: activar bases individuales por texto
const [baseIndividual, setBaseIndividual] = useState(false);


// Valores iniciales para bases individuales
const [baseOffset1, setBaseOffset1] = useState({ x: 0, y: -1.4, z: -1.92 });
const [baseOffset2, setBaseOffset2] = useState({ x: 0, y: -1.4, z: -1.25 });
const [baseOffset3, setBaseOffset3] = useState({ x: 0, y: -1.4, z: 0.03 });

const [glbPos, setGlbPos] = useState({ x: 0, y: 0, z: 0 });
const [glbScale, setGlbScale] = useState(1);

const [colorFondo, setColorFondo] = useState("#111111");

// === LUCES ===
const [intensidadLuz, setIntensidadLuz] = useState(1);
const [colorLuz, setColorLuz] = useState("#ffffff");
const [lucesActivas, setLucesActivas] = useState({
  frontal: true,
  izquierda: false,
  derecha: false,
  superior: false,
  inferior: false,
  trasera: false,
});

const [openDescargas, setOpenDescargas] = useState(false);

const [glbActivo, setGlbActivo] = useState(null); // "izquierda" | "derecha" | null


const baseRef1 = useRef();
const baseRef2 = useRef();
const baseRef3 = useRef();

const [responsiveScale, setResponsiveScale] = useState(1);


// transformaciones por cada GLB (pos & scale)
const [glbTransforms, setGlbTransforms] = useState({
  izquierda: { pos: { x: 0, y: 0, z: 0 }, scale: 1 },
  derecha:  { pos: { x: 0, y: 0, z: 0 }, scale: 1 },
});



const handleCargarModelo = (lado) => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = ".glb";
  input.onchange = (e) => {
    const archivo = e.target.files[0];
    if (!archivo) return;
    const url = URL.createObjectURL(archivo);
    
    const loader = new GLTFLoader();
    loader.load(
      url,
      (gltf) => {
        const modelo = gltf.scene;

        // busca el primer mesh real
let mesh = modelo;
modelo.traverse((child) => {
  if (child.isMesh && !mesh.isMesh) mesh = child;
});

        // ✅ Normaliza el pivote al centro geométrico
        const box = new THREE.Box3().setFromObject(modelo);
        const center = new THREE.Vector3();
        box.getCenter(center);
        modelo.position.sub(center); // mueve el modelo para que su centro quede en (0,0,0)
        
        // ✅ Escala automática proporcional al ancho de la base
        const size = new THREE.Vector3();
        box.getSize(size);
        const maxDim = Math.max(size.x, size.y, size.z);
        const escalaBase = 10 / maxDim; // ajusta 10 → puedes probar 8, 12, etc.
        modelo.scale.setScalar(escalaBase);
        
        // recalcula tras escalar
        const box2 = new THREE.Box3().setFromObject(modelo);
        const center2 = new THREE.Vector3();
        box2.getCenter(center2);
        modelo.position.sub(center2);
        
        // ✅ Habilita sombras y demás
        modelo.traverse((child) => {
          if (child.isMesh) {
            child.castShadow = true;
            child.receiveShadow = true;
          }
        });
        

        if (lado === "izquierda") setModeloIzquierda(modelo);
        if (!glbActivo) setGlbActivo("izquierda");

        if (lado === "derecha") setModeloDerecha(modelo);
        if (!glbActivo) setGlbActivo("derecha");

      },
      (xhr) => console.log((xhr.loaded / xhr.total) * 100 + "% cargado"),
      (error) => console.error("Error al cargar GLB:", error)
    );
  };
  input.click();
};
function bakeObjectToWorld(obj) {
  // obj: THREE.Object3D (mesh o group)
  obj.updateWorldMatrix(true, true);
  const clone = obj.clone(true);

  clone.traverse((child) => {
    if (child.isMesh && child.geometry) {
      child.updateMatrixWorld(true);
      // clonar la geometría y aplicar la matriz world
      const geom = child.geometry.clone();
      geom.applyMatrix4(child.matrixWorld);
      child.geometry = geom;
      // reset transforms (ya están “bakeadas” en la geometría)
      child.matrix.identity();
      child.position.set(0, 0, 0);
      child.rotation.set(0, 0, 0);
      child.scale.set(1, 1, 1);
    }
  });

  return clone;
}
const handleDescargarSTL = (tipo, indice = null) => {
  const exporter = new STLExporter();
  let objeto = null;
  let nombreArchivo = "modelo.stl";

  // grupo donde juntamos todo ya bakeado
  const grupo = new THREE.Group();

  if (tipo === "texto" && indice) {
    let refTexto = null;
    let refBase = null;

    if (indice === 1) {
      refTexto = ref1.current;
      refBase = baseRef1?.current;
    }
    if (indice === 2) {
      refTexto = ref2.current;
      refBase = baseRef2?.current;
    }
    if (indice === 3) {
      refTexto = ref3.current;
      refBase = baseRef3?.current;
    }

    if (!refTexto) {
      alert("❌ No se encontró el texto a exportar.");
      return;
    }

    // Bake and add text
    try {
      const textoBake = bakeObjectToWorld(refTexto);
      grupo.add(textoBake);
    } catch (e) {
      console.error("Error bake texto:", e);
    }

    // Bake and add base if existe
    if (refBase) {
      try {
        const baseBake = bakeObjectToWorld(refBase);
        grupo.add(baseBake);
      } catch (e) {
        console.warn("No se pudo bakear la base:", e);
      }
    }

    objeto = grupo;
    nombreArchivo = `texto_con_base_${indice}.stl`;
  } else if (tipo === "base") {
    if (indice === "normal") {
      // si tienes un mesh global para la base normal, úsalo (ejemplo: baseRef1)
      objeto = baseRef1?.current || baseRef2?.current || baseRef3?.current;
    } else if (indice === "izquierda") {
      objeto = modeloIzquierda;
    } else if (indice === "derecha") {
      objeto = modeloDerecha;
    }
    nombreArchivo = `base_${indice}.stl`;
  }

  if (!objeto) {
    alert("❌ No se encontró el modelo a exportar.");
    return;
  }



  // Si es un único objeto (no grupo), bakearlo también para seguridad
  let target = objeto;
  if (objeto.isMesh || objeto.isGroup || objeto.isObject3D) {
    // puede ser un mesh o group; bake si no es ya un grupo con geometrías bakeadas
    try {
      target = bakeObjectToWorld(objeto);
    } catch (e) {
      console.warn("No se pudo bakear objeto, se exporta tal cual:", e);
      target = objeto;
    }
  }

  // parse acepta Object3D
  const stlString = exporter.parse(target);
  const blob = new Blob([stlString], { type: "application/vnd.ms-pki.stl" });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = nombreArchivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setOpenDescargas(false);
};






  // === Todas tus fuentes ===
const fuentesDisponibles = {
  // === ANTERIORES ===
  "Super Vanilla": SuperVanilla,
  "Spooky Cartoon": SpookyCartoon,
  "Kind Daily": KindDaily,
  "Candy Beans": CandyBeans,
  "The Last Shuriken": LastShuriken,
  "Transformers Movie": TransformersMovie,
  "Zombie Zone": ZombieZone,
  "Toasty Milk": ToastyMilk,
  "Karate": Karate,
  "Simply Rounded": SimplyRounded,
  "Halo Dek": HaloDek,
  "Sunday Midnight": SundayMidnight,

  // === NUEVAS ===
  "Lovely Heart": LovelyHeart,
  "Meow in Love Demo": MeowInLove,
  "Maximum Voltage": MaximumVoltage,
  "Maximum Voltage Italic": MaximumVoltageItalic,
  "Vampire Wars": VampireWars,
  "Vampire Wars Italic": VampireWarsItalic,
  "Gimbot": Gimbot,
  "Billy Bounce": BillyBounce,
  "BlackCastleMF": BlackCastleMF,
  "Candy Shop": CandyShop,
  "Candy Shop Black": CandyShopBlack,
  "AngryBirds": AngryBirds,
  "Tomcat": Tomcat,
  "Comicoon": Comicoon,
  "Grinched": Grinched,
  "Kraash": Kraash,
  "Kraash Black": KraashBlack,
  "Powerful": Powerful,
  "Milky Nice": MilkyNice,
  "Milky Nice Clean": MilkyNiceClean,
  "Super Mario 256": SuperMario256,
  "Dinosaur": Dinosaur,
  "Sealight Whisper": SealightWhisper,
  "Yourmate": Yourmate,
  "BubbleGum": BubbleGum,
  "Magic Sound": MagicSound,
  "Bestime": Bestime,
  "Super Boys": SuperBoys,
  "Milkshake Creps": MilkshakeCreps,
  "GrindAndDeath Demo": GrindAndDeath,
  "God Of War": GodOfWar,
  "Dynamix": Dynamix,
};
  const resetTodo = () => {
    setRotacion({
      x: THREE.MathUtils.degToRad(-90),
      y: 0,
      z: THREE.MathUtils.degToRad(180),
    });
    setPosicion({ x: 0, y: 0, z: 0 });
  };
  const rotar = (axis, grados) => {
    if (modeloActivo === 1) {
      setRotacion((prev) => ({
        ...prev,
        [axis]: prev[axis] + THREE.MathUtils.degToRad(grados),
      }));
    } else if (modeloActivo === 2) {
      setRot2((prev) => ({
        ...prev,
        [axis]: prev[axis] + THREE.MathUtils.degToRad(grados),
      }));
    } else if (modeloActivo === 3) {
      setRot3((prev) => ({
        ...prev,
        [axis]: prev[axis] + THREE.MathUtils.degToRad(grados),
      }));
    }
  };
  
  const updateGlbPos = (side, axis, delta) => {
    if (!side) {
      console.warn("Ningún GLB seleccionado");
      return;
    }
    setGlbTransforms(prev => ({
      ...prev,
      [side]: {
        ...prev[side],
        pos: {
          ...prev[side].pos,
          [axis]: prev[side].pos[axis] + delta,
        },
      },
    }));
  };
  
  const updateGlbScale = (side, delta) => {
    if (!side) {
      console.warn("Ningún GLB seleccionado");
      return;
    }
    setGlbTransforms(prev => ({
      ...prev,
      [side]: {
        ...prev[side],
        scale: Math.max(0.01, prev[side].scale + delta),
      },
    }));
  };
  
  // opcional: reset de transform del lado activo (si quieres)
  const resetGlbTransform = (side) => {
    setGlbTransforms(prev => ({
      ...prev,
      [side]: { pos: { x: 0, y: 0, z: 0 }, scale: 1 },
    }));
  };
  


  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();


  ////////////////////////////////////////////////////////////////////////////////////////
  const loader = new FontLoader();
const font = useMemo(() => {
  const fuenteJSON = fuentesDisponibles[fuenteSeleccionada];
  if (!fuenteJSON) return null;
  try {
    return loader.parse(fuenteJSON);
  } catch (e) {
    console.error("Error cargando fuente:", fuenteSeleccionada, e);
    return null;
  }
}, [fuenteSeleccionada]);
const font2 = useMemo(() => {
  const fuenteJSON = fuentesDisponibles[fuente2];
  return fuenteJSON ? loader.parse(fuenteJSON) : null;
}, [fuente2]);
const font3 = useMemo(() => {
  const fuenteJSON = fuentesDisponibles[fuente3];
  return fuenteJSON ? loader.parse(fuenteJSON) : null;
}, [fuente3]);

/////////////////////////////////////////////////////////////////

/////////////////////////////
// --- Responsive helper ---
const [vw, setVw] = useState(
  typeof window !== "undefined" ? window.innerWidth : 1200
);

useEffect(() => {
  const onResize = () => setVw(window.innerWidth);
  window.addEventListener("resize", onResize);
  return () => window.removeEventListener("resize", onResize);
}, []);

// uiScale: 1 en pantallas grandes, baja hasta 0.5 en pantallas muy pequeñas
const uiScale = Math.min(1, Math.max(0.5, vw / 1100)); // ajusta el 1100 si quieres que el cambio ocurra antes/después

// helper para tamaños en px
const scaledPx = (px) => Math.round(px * uiScale);

// helper para objetos de estilo: crea una copia escalada simple (usa donde haga falta)
const scaleStyle = (styleObj = {}) => {
  const scaled = { ...styleObj };
  if (styleObj.width && typeof styleObj.width === "number") scaled.width = scaledPx(styleObj.width);
  if (styleObj.fontSize && typeof styleObj.fontSize === "number") scaled.fontSize = Math.max(10, Math.round(styleObj.fontSize * uiScale));
  if (styleObj.padding && typeof styleObj.padding === "string") {
    // opcional: no tocar si padding en string, lo dejamos
  }
  return scaled;
};

// Ajuste visual para el grupo 3D (reduce modelo en pantallas pequeñas)
const responsiveGroupScale = Math.max(0.6, Math.min(1.2, vw / 1000)); // 1 en 1000px, más pequeño en móviles

//////////////////////////////////////

///------------Detecta el ancho de pantalla y calcula escala
useEffect(() => {
  const actualizarEscala = () => {
    const w = window.innerWidth;
    if (w >= 1024) setResponsiveScale(1);       // PC
    else if (w >= 600) setResponsiveScale(0.80); // Tablet
    else setResponsiveScale(0.65);               // Celular
  };

  actualizarEscala();
  window.addEventListener("resize", actualizarEscala);

  return () => window.removeEventListener("resize", actualizarEscala);
}, []);



  // Cargar estado guardado
useEffect(() => {
  const data = localStorage.getItem("textoArqueado");
  if (data) {
    const parsed = JSON.parse(data);
    setTexto(parsed.texto || "3D Fyrion");
    setFuenteSeleccionada(parsed.fuenteSeleccionada || "Super Vanilla");
    setRotacion(parsed.rotacion || { x: THREE.MathUtils.degToRad(-90), y: 0, z: THREE.MathUtils.degToRad(180) });
    setPosicion(parsed.posicion || { x: 0, y: 0, z: 0 });
    setZoom(parsed.zoom || 80);
    setRadio(parsed.radio || 8);
    setMostrarBase(parsed.mostrarBase !== undefined ? parsed.mostrarBase : true);
    setPosBase(parsed.posBase || { x: 0, y: 2, z: -6 });
    setRotBase(parsed.rotBase || { x: THREE.MathUtils.degToRad(-90), y: 0, z: 0 });

    setTexto2(parsed.texto2 || "Texto 2");
    setFuente2(parsed.fuente2 || "Super Vanilla");
    setPos2(parsed.pos2 || { x: 0, y: -1.5, z: 3 });
    setRot2(parsed.rot2 || { x: THREE.MathUtils.degToRad(-90), y: 0, z: THREE.MathUtils.degToRad(180) });
    setRadio2(parsed.radio2 || 5);

    setTexto3(parsed.texto3 || "Texto 3");
    setFuente3(parsed.fuente3 || "Super Vanilla");
    setPos3(parsed.pos3 || { x: 0, y: -3.2, z: 6 });
    setRot3(parsed.rot3 || { x: THREE.MathUtils.degToRad(-90), y: 0, z: THREE.MathUtils.degToRad(180) });
    setRadio3(parsed.radio3 || 1);

    // 🎨 Cargar colores correctamente
    setColorTexto1(parsed.colorTexto1 || "#00ccff");
    setColorTexto2(parsed.colorTexto2 || "#ff00ff");
    setColorTexto3(parsed.colorTexto3 || "#ffaa00");
    setColorBase(parsed.colorBase || "#0066aa");
    setColorGeneral(parsed.colorGeneral || "#ffffff");
    setUsarColorGeneral(parsed.usarColorGeneral || false);
    setColorFondo(parsed.colorFondo || "#111111");



  }

  // Señal de que ya cargó todo
  setTimeout(() => setCargado(true), 200);
}, []);

  // 🔹 NUEVO useEffect para mantener proporciones en todas las pantallas
useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;

      let scale;
      if (w < 480) scale = 0.6;
      else if (w < 768) scale = 0.75;
      else if (w < 1200) scale = 0.9;
      else scale = 1.0;

      setGroupScale(scale);
      setRadio(8 * scale);
      setRadio2(5 * scale);
      setRadio3(1 * scale);

      setPos2({ x: 0, y: -1.5 * scale, z: 3 * scale });
      setPos3({ x: 0, y: -3.2 * scale, z: 6 * scale });
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

useEffect(() => {
  if (!cargado) return; // 🔒 evita guardar antes de cargar
  const data = {
    texto,
    fuenteSeleccionada,
    rotacion,
    posicion,
    zoom,
    radio,
    mostrarBase,
    posBase,
    rotBase,
    texto2,
    fuente2,
    pos2,
    rot2,
    radio2,
    texto3,
    fuente3,
    pos3,
    rot3,
    radio3,
    colorTexto1, colorTexto2, colorTexto3, colorBase, colorGeneral, usarColorGeneral,colorFondo,
  };
  localStorage.setItem("textoArqueado", JSON.stringify(data));
}, [
  cargado,
  texto, fuenteSeleccionada, rotacion, posicion, zoom, radio,
  mostrarBase, posBase, rotBase,
  texto2, fuente2, pos2, rot2, radio2,
  texto3, fuente3, pos3, rot3, radio3,
  colorTexto1, colorTexto2, colorTexto3, colorBase, colorGeneral, usarColorGeneral, colorFondo,
]);

//Verifica si se carga el glb o no
useEffect(() => {
  if (modeloIzquierda) {
    console.log("✅ Modelo izquierda cargado:", modeloIzquierda);
  }
  if (modeloDerecha) {
    console.log("✅ Modelo derecha cargado:", modeloDerecha);
  }
}, [modeloIzquierda, modeloDerecha]);

// === Control dinámico del offset de BaseAutomatica según cantidad de textos llenos ===
useEffect(() => {
  const llenos = [texto, texto2, texto3].filter(t => t.trim() !== "").length;
  if (llenos === 3) {
    setOffsetY(2);
  } else if (llenos === 2) {
    setOffsetY(4);
  } else if (llenos === 1) {
    setOffsetY(6);
  } else {
    setOffsetY(6); // por si están vacíos todos, puedes dejar el mismo valor del caso 1
  }
}, [texto, texto2, texto3]);

useEffect(() => {
  if (!glbActivo) {
    if (modeloIzquierda && !modeloDerecha) setGlbActivo("izquierda");
    else if (!modeloIzquierda && modeloDerecha) setGlbActivo("derecha");
  }
}, [modeloIzquierda, modeloDerecha]);



return (
<div style={{ width: "100%", height: "100vh", background: colorFondo, position: "relative" }}>




{/* === BOTÓN DESCARGAR STLs === */}
<div style={{ bottom: 0, left: 20 }}>
  <Button
    variant="contained"
    color="primary"
    startIcon={<DownloadIcon />}
    onClick={() => setOpenDescargas(true)}
    style={{
      background: "#007BFF",
      color: "#fff",
      borderRadius: 12,
      fontWeight: "bold",
      textTransform: "none",
    }}
  >
    Descargar STLs
  </Button>
</div>

{/* === ALERT DIALOG DE DESCARGAS === */}
<Dialog
  open={openDescargas}
  onClose={() => setOpenDescargas(false)}
  PaperProps={{
    style: {
      backgroundColor: "#000",
      color: "#fff",
      borderRadius: 16,
      minWidth: 280,
    },
  }}
>
  <DialogTitle style={{ borderBottom: "1px solid #333" }}>
    📦 Descargar STLs
  </DialogTitle>

  <DialogContent>
    {baseIndividual && (
      <>
        <h4 style={{ color: "#00bfff", marginBottom: 6 }}>🧱 Textos Individuales</h4>
        {[texto, texto2, texto3].map(
          (t, i) =>
            t.trim() !== "" && (
              <Button
                key={i}
                variant="contained"
                fullWidth
                onClick={() => handleDescargarSTL("texto", i + 1)}
                style={{
                  marginBottom: 8,
                  backgroundColor: "#007bff",
                  color: "#fff",
                  borderRadius: 10,
                  textTransform: "none",
                }}
              >
                Texto {i + 1}
              </Button>
            )
        )}
        <div style={{ marginTop: 16, marginBottom: 12, borderTop: "1px solid #222" }} />
      </>
    )}

    <h4 style={{ color: "#00bfff", marginBottom: 6 }}>⚙️ Base General</h4>
    {["Normal", "Izquierda", "Derecha", "Ambos"].map((tipo) => (
      <Button
        key={tipo}
        variant="contained"
        fullWidth
        onClick={() => handleDescargarSTL("base", tipo.toLowerCase())}
        style={{
          marginBottom: 8,
          backgroundColor: "#007bff",
          color: "#fff",
          borderRadius: 10,
          textTransform: "none",
        }}
      >
        {tipo}
      </Button>
    ))}
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() => setOpenDescargas(false)}
      style={{ color: "#ccc", textTransform: "none" }}
    >
      Cerrar
    </Button>
  </DialogActions>
</Dialog>




    {/* Input texto 1 */}
    <div style={{ ...filaColor, top: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <input
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          placeholder="Escribe tu texto..."
          style={{ ...inputStyle, width: 160 }}
        />
        <div
          style={{
            ...circuloColor,
            background: usarColorGeneral ? colorGeneral : colorTexto1,
            marginLeft: 6,
          }}
          onClick={() => document.getElementById("colorTexto1").click()}
        ></div>
        <input
          id="colorTexto1"
          type="color"
          value={colorTexto1}
          onChange={(e) => setColorTexto1(e.target.value)}
          style={{ display: "none" }}
        />
      </div>
    </div>

    {/* Selector de fuente */}
    <select
      value={fuenteSeleccionada}
      onChange={(e) => setFuenteSeleccionada(e.target.value)}
      style={selectStyle}
    >
      {Object.keys(fuentesDisponibles).map((nombre) => (
        <option key={nombre} value={nombre}>
          {nombre}
        </option>
      ))}
    </select>

    {/* Input texto 2 */}
    <div style={{ ...filaColor, top: 80 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <input
          value={texto2}
          onChange={(e) => setTexto2(e.target.value)}
          placeholder="Escribe tu texto..."
          style={{ ...inputStyle, width: 160 }}
        />
        <div
          style={{
            ...circuloColor,
            background: usarColorGeneral ? colorGeneral : colorTexto2,
            marginLeft: 6,
          }}
          onClick={() => document.getElementById("colorTexto2").click()}
        ></div>
        <input
          id="colorTexto2"
          type="color"
          value={colorTexto2}
          onChange={(e) => setColorTexto2(e.target.value)}
          style={{ display: "none" }}
        />
      </div>
    </div>

    {/* Fuente modelo 2 */}
    <select
      value={fuente2}
      onChange={(e) => setFuente2(e.target.value)}
      style={{ ...selectStyle, top: 70 }}
    >
      {Object.keys(fuentesDisponibles).map((nombre) => (
        <option key={nombre} value={nombre}>
          {nombre}
        </option>
      ))}
    </select>

    {/* Input texto 3 */}
    <div style={{ ...filaColor, top: 140 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <input
          value={texto3}
          onChange={(e) => setTexto3(e.target.value)}
          placeholder="Escribe tu texto..."
          style={{ ...inputStyle, width: 160 }}
        />
        <div
          style={{
            ...circuloColor,
            background: usarColorGeneral ? colorGeneral : colorTexto3,
            marginLeft: 6,
          }}
          onClick={() => document.getElementById("colorTexto3").click()}
        ></div>
        <input
          id="colorTexto3"
          type="color"
          value={colorTexto3}
          onChange={(e) => setColorTexto3(e.target.value)}
          style={{ display: "none" }}
        />
      </div>
    </div>

    {/* Fuente modelo 3 */}
    <select
      value={fuente3}
      onChange={(e) => setFuente3(e.target.value)}
      style={{ ...selectStyle, top: 120 }}
    >
      {Object.keys(fuentesDisponibles).map((nombre) => (
        <option key={nombre} value={nombre}>
          {nombre}
        </option>
      ))}
    </select>


    {/* === CONTROLES GENERALES === */}
    <div style={panelGeneral}>
      {/* === NUEVOS CHECKBOXES DE BASE === */}
      {mostrarBase && (
        <div
          style={{
            marginTop: 10,
            background: "rgba(30,30,30,0.9)",
            padding: 10,
            borderRadius: 8,
            border: "1px solid #555",
            color: "white",
            width: 180,
            fontSize: 14,
          }}
        >
          <h4 style={{ marginTop: 0, marginBottom: 8 }}>🧱 Tipo de Base</h4>
          {["normal", "izquierda", "derecha", "ambos"].map((tipo) => (
            <label key={tipo} style={{ display: "block", marginBottom: 4 }}>
              <input
                type="radio"
                name="tipoBase"
                value={tipo}
                checked={tipoBase === tipo}
                onChange={() => setTipoBase(tipo)}
              />{" "}
              {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
            </label>
          ))}

          {/* checkbox Individual */}
<label style={{ display: "block", marginTop: 8 }}>
  <input
    type="checkbox"
    checked={baseIndividual}
    onChange={(e) => setBaseIndividual(e.target.checked)}
    style={{ marginRight: 8 }}
  />
  Individual (una base pequeña por cada texto)
</label>



{/* Sliders para ajustar bases individuales (solo si baseIndividual = true)
 
 */}

{baseIndividual && (
  <div style={{ color: "white", marginTop: 8, width: 220 }}>
    <strong style={{display:"block", marginBottom:4}}>Ajuste base 1</strong>
    <label>X: {baseOffset1.x.toFixed(2)}
      <input type="range" min={-5} max={5} step={0.01} value={baseOffset1.x}
        onChange={(e)=> setBaseOffset1(prev=>({...prev, x: Number(e.target.value)}))}
        style={{ width: "100%" }}/>
    </label>
    <label>Y: {baseOffset1.y.toFixed(2)}
      <input type="range" min={-5} max={5} step={0.01} value={baseOffset1.y}
        onChange={(e)=> setBaseOffset1(prev=>({...prev, y: Number(e.target.value)}))}
        style={{ width: "100%" }}/>
    </label>
    <label>Z: {baseOffset1.z.toFixed(2)}
      <input type="range" min={-5} max={5} step={0.01} value={baseOffset1.z}
        onChange={(e)=> setBaseOffset1(prev=>({...prev, z: Number(e.target.value)}))}
        style={{ width: "100%" }}/>
    </label>

    <strong style={{display:"block", marginTop:8}}>Ajuste base 2</strong>
<label>X: {baseOffset2.x.toFixed(2)}
  <input type="range" min={-5} max={5} step={0.01} value={baseOffset2.x}
    onChange={(e)=> setBaseOffset2(prev=>({...prev, x: Number(e.target.value)}))}
    style={{ width: "100%" }}/>
</label>
<label>Y: {baseOffset2.y.toFixed(2)}
  <input type="range" min={-5} max={5} step={0.01} value={baseOffset2.y}
    onChange={(e)=> setBaseOffset2(prev=>({...prev, y: Number(e.target.value)}))}
    style={{ width: "100%" }}/>
</label>
<label>Z: {baseOffset2.z.toFixed(2)}
  <input type="range" min={-5} max={5} step={0.01} value={baseOffset2.z}
    onChange={(e)=> setBaseOffset2(prev=>({...prev, z: Number(e.target.value)}))}
    style={{ width: "100%" }}/>
</label>

<strong style={{display:"block", marginTop:8}}>Ajuste base 3</strong>
<label>X: {baseOffset3.x.toFixed(2)}
  <input type="range" min={-5} max={5} step={0.01} value={baseOffset3.x}
    onChange={(e)=> setBaseOffset3(prev=>({...prev, x: Number(e.target.value)}))}
    style={{ width: "100%" }}/>
</label>
<label>Y: {baseOffset3.y.toFixed(2)}
  <input type="range" min={-5} max={5} step={0.01} value={baseOffset3.y}
    onChange={(e)=> setBaseOffset3(prev=>({...prev, y: Number(e.target.value)}))}
    style={{ width: "100%" }}/>
</label>
<label>Z: {baseOffset3.z.toFixed(2)}
  <input type="range" min={-5} max={5} step={0.01} value={baseOffset3.z}
    onChange={(e)=> setBaseOffset3(prev=>({...prev, z: Number(e.target.value)}))}
    style={{ width: "100%" }}/>
</label>

    <div style={{ fontSize: 12, opacity: 0.8, marginTop:6 }}>
      Usa X/Y/Z para alinear; los valores son unidades de la escena.
    </div>
  </div>
)}

        </div>
      
      )}


{tipoBase === "izquierda" && (
  <button
    onClick={() => handleCargarModelo("izquierda")}
    style={{ ...btnReset, background: "#3399ff", marginTop: 8 }}
  >
    Añadir Diseño Izquierda
  </button>
)}
{tipoBase === "derecha" && (
  <button
    onClick={() => handleCargarModelo("derecha")}
    style={{ ...btnReset, background: "#3399ff", marginTop: 8 }}
  >
    Añadir Diseño Derecha
  </button>
)}
{tipoBase === "ambos" && (
  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
    <button
      onClick={() => handleCargarModelo("izquierda")}
      style={{ ...btnReset, background: "#3399ff" }}
    >
      Añadir Diseño Izquierda
    </button>
    <button
      onClick={() => handleCargarModelo("derecha")}
      style={{ ...btnReset, background: "#3399ff" }}
    >
      Añadir Diseño Derecha
    </button>
  </div>
)}




      <button onClick={resetTodo} style={btnReset}>
        Reset Todo
      </button>
      {/* === Botón para poner base === */}
      <button
        onClick={() => setMostrarBase((prev) => !prev)}
        style={{ ...btnReset, background: mostrarBase ? "#ff5555" : "#44ff66" }}
      >
        {mostrarBase ? "Quitar Base" : "Poner Base"}
      </button>
    </div>


    {/* === Controles de zoom y radio === */}
    <div style={panelZoom}>

{/* === PANEL DE ILUMINACIÓN === */}
<div
  style={{
    marginTop: 20,
    background: "rgba(30,30,30,0.95)",
    padding: 12,
    borderRadius: 10,
    border: "1px solid #666",
    color: "white",
    fontSize: 14,
  }}
>
  <h4 style={{ marginTop: 0, marginBottom: 10 }}>💡 Iluminación</h4>

  {/* Intensidad global */}
  <label>
    Intensidad: {intensidadLuz.toFixed(2)}
    <input
      type="range"
      min={0}
      max={3}
      step={0.01}
      value={intensidadLuz}
      onChange={(e) => setIntensidadLuz(Number(e.target.value))}
      style={{ width: "100%" }}
    />
  </label>

  {/* Color de luz */}
  <div style={{ marginTop: 8 }}>
    <span>Color de luz: </span>
    <div
      style={{
        ...circuloColor,
        background: colorLuz,
        display: "inline-block",
        marginLeft: 8,
      }}
      onClick={() => document.getElementById("colorLuz").click()}
    ></div>
    <input
      id="colorLuz"
      type="color"
      value={colorLuz}
      onChange={(e) => setColorLuz(e.target.value)}
      style={{ display: "none" }}
    />
  </div>

  {/* Direcciones de luz */}
  <div style={{ marginTop: 12 }}>
    <strong>Direcciones:</strong>
    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 6 }}>
      {[
        { nombre: "Frontal", key: "frontal" },
        { nombre: "Izquierda", key: "izquierda" },
        { nombre: "Derecha", key: "derecha" },
        { nombre: "Superior", key: "superior" },
        { nombre: "Inferior", key: "inferior" },
        { nombre: "Trasera", key: "trasera" },
      ].map((dir) => (
        <button
          key={dir.key}
          onClick={() =>
            setLucesActivas((prev) => ({
              ...prev,
              [dir.key]: !prev[dir.key],
            }))
          }
          style={{
            background: lucesActivas[dir.key] ? "#00ccff" : "#333",
            color: "white",
            border: "none",
            borderRadius: 6,
            padding: "4px 8px",
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          {dir.nombre}
        </button>
      ))}
    </div>
  </div>

  {/* Botón reset luz */}
  <button
    onClick={() => {
      setIntensidadLuz(1);
      setColorLuz("#ffffff");
      setLucesActivas({
        frontal: true,
        izquierda: false,
        derecha: false,
        superior: false,
        inferior: false,
        trasera: false,
      });
    }}
    style={{
      marginTop: 10,
      background: "#cc0000",
      color: "white",
      border: "none",
      borderRadius: 6,
      padding: "5px 10px",
      cursor: "pointer",
      width: "100%",
    }}
  >
    🔄 Reset Luz
  </button>
</div>


      {/* 🎨 Selector de color de fondo */}
<div style={{ top: 200, left: 20, display: "flex", alignItems: "center", gap: 10 }}>
  <span style={{ color: "white", fontSize: 14 }}>Fondo:</span>
  <div
    onClick={() => document.getElementById("colorFondo").click()}
    style={{
      width: 24,
      height: 24,
      borderRadius: "50%",
      border: "1px solid #aaa",
      background: colorFondo,
      cursor: "pointer",
    }}
  />
  <input
    id="colorFondo"
    type="color"
    value={colorFondo}
    onChange={(e) => setColorFondo(e.target.value)}
    style={{ display: "none" }}
  />
</div>


            {/* === BOTONERA DE CONTROL GLB === */}
<div
  style={{
    Top:-55,
    bottom: 20,
    right: 20,
    background: "rgba(20,20,20,0.9)",
    padding: 12,
    borderRadius: 12,
    border: "1px solid #444",
    color: "white",
    fontSize: 13,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 6,
    zIndex: 20
  }}
>
  <div style={{ fontWeight: "bold", marginBottom: 4 }}>🎮 Control GLB</div>

  {/* === SELECCIÓN DE MODELO GLB ACTIVO === */}
{(modeloIzquierda || modeloDerecha) && (
  <div style={{
    background: "#222",
    color: "#fff",
    padding: "10px 15px",
    borderRadius: 10,
    margin: "10px 0",
  }}>
    <h4 style={{ margin: 0, fontSize: 14 }}>🎯 Selecciona modelo a controlar</h4>
    <div style={{ marginTop: 6 }}>
      {modeloIzquierda && (
        <label style={{ display: "block", marginBottom: 4 }}>
          <input
            type="radio"
            name="glbActivo"
            checked={glbActivo === "izquierda"}
            onChange={() => setGlbActivo("izquierda")}
          />{" "}
          Modelo Izquierda
        </label>
      )}
      {modeloDerecha && (
        <label style={{ display: "block", marginBottom: 4 }}>
          <input
            type="radio"
            name="glbActivo"
            checked={glbActivo === "derecha"}
            onChange={() => setGlbActivo("derecha")}
          />{" "}
          Modelo Derecha
        </label>
      )}
    </div>
  </div>
)}

  
<div style={{ display: "grid", gridTemplateColumns: "repeat(3, 32px)", gap: 4 }}>
  <button onClick={() => updateGlbPos(glbActivo, "y", 0.2)}>⬆️</button>
  <div></div>
  <button onClick={() => updateGlbPos(glbActivo, "y", -0.2)}>⬇️</button>

  <button onClick={() => updateGlbPos(glbActivo, "x", -0.2)}>⬅️</button>
  <button onClick={() => updateGlbPos(glbActivo, "z", 0.2)}>🔼</button>
  <button onClick={() => updateGlbPos(glbActivo, "x", 0.2)}>➡️</button>

  <div></div>
  <button onClick={() => updateGlbPos(glbActivo, "z", -0.2)}>🔽</button>
  <div></div>
</div>

<div style={{ marginTop: 8 }}>
  <button onClick={() => updateGlbScale(glbActivo, 0.1)} style={{ marginRight: 6 }}>🔍 +</button>
  <button onClick={() => updateGlbScale(glbActivo, -0.1)}>🔎 -</button>
</div>

<div style={{ marginTop: 6, textAlign: "center" }}>
  <div>📍 X: {(glbActivo ? glbTransforms[glbActivo].pos.x : 0).toFixed(2)}</div>
  <div>📍 Y: {(glbActivo ? glbTransforms[glbActivo].pos.y : 0).toFixed(2)}</div>
  <div>📍 Z: {(glbActivo ? glbTransforms[glbActivo].pos.z : 0).toFixed(2)}</div>
  <div>📏 Escala: {(glbActivo ? glbTransforms[glbActivo].scale : 1).toFixed(2)}</div>
</div>

</div>

      <label>
        Zoom: {zoom}
        <input
          type="range"
          min="40"
          max="150"
          value={zoom}
          onChange={(e) => setZoom(Number(e.target.value))}
          style={{ width: "100%" }}
        />
      </label>
      <label>
        Radio: {radio}
        <input
          type="range"
          min="5"
          max="60"
          value={radio}
          onChange={(e) => setRadio(Number(e.target.value))}
          style={{ width: "100%" }}
        />
      </label>
      <label>
        <input
          type="checkbox"
          checked={autoRotar}
          onChange={(e) => setAutoRotar(e.target.checked)}
          style={{ marginRight: 8 }}
        />
        Rotar automáticamente
      </label>
    </div>

    {/* === Control General de Colores === */}
    <div style={{ position: "absolute", top: 220, left: 20, color: "white", zIndex: 10 }}>
      <label style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div
          style={{ ...circuloColor, background: colorGeneral }}
          onClick={() => document.getElementById("colorGeneral").click()}
        ></div>
        <input
          id="colorGeneral"
          type="color"
          value={colorGeneral}
          onChange={(e) => setColorGeneral(e.target.value)}
          style={{ display: "none" }}
        />
        <span>Usar color general</span>
        <input
          type="checkbox"
          checked={usarColorGeneral}
          onChange={(e) => setUsarColorGeneral(e.target.checked)}
        />
      </label>

      <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10 }}>
        <div
          style={{ ...circuloColor, background: colorBase }}
          onClick={() => document.getElementById("colorBase").click()}
        ></div>
        <input
          id="colorBase"
          type="color"
          value={colorBase}
          onChange={(e) => setColorBase(e.target.value)}
          style={{ display: "none" }}
        />
        <span>Color de la base</span>
      </label>
    </div>

    {/* === Canvas 3D === */}
    <Canvas camera={{ position: [0, 10, 30], fov: 40 }}>
<mesh position={[0, 0, 0]}>
  <sphereGeometry args={[0.1, 16, 16]} />
  <meshBasicMaterial color="yellow" />
</mesh>
  <AjusteCamaraResponsive setZoom={setZoom} />
      <AjusteCamaraResponsive setZoom={setZoom} />
<ambientLight intensity={1} />
<directionalLight position={[10, 10, 10]} intensity={2} />
      <group scale={[groupScale, groupScale, groupScale]}>


      {lucesActivas.frontal && (
  <directionalLight
    position={[0, 0, 10]}
    intensity={intensidadLuz}
    color={colorLuz}
  />
)}
{lucesActivas.trasera && (
  <directionalLight
    position={[0, 0, -10]}
    intensity={intensidadLuz * 0.7}
    color={colorLuz}
  />
)}
{lucesActivas.izquierda && (
  <directionalLight
    position={[-10, 0, 0]}
    intensity={intensidadLuz}
    color={colorLuz}
  />
)}
{lucesActivas.derecha && (
  <directionalLight
    position={[10, 0, 0]}
    intensity={intensidadLuz}
    color={colorLuz}
  />
)}
{lucesActivas.superior && (
  <directionalLight
    position={[0, 10, 0]}
    intensity={intensidadLuz}
    color={colorLuz}
  />
)}
{lucesActivas.inferior && (
  <directionalLight
    position={[0, -10, 0]}
    intensity={intensidadLuz}
    color={colorLuz}
  />
)}
<ambientLight intensity={0.3} />






        {font && (
          <TextoExtrusionVertical
            ref={ref1}
            font={font}
            texto={texto}
            radio={radio}
            rotar={autoRotar}
            rotacion={rotacion}
            posicion={posicion}
            color={usarColorGeneral ? colorGeneral : colorTexto1}
          />
        )}
        {font2 && (
          <TextoExtrusionVertical
            ref={ref2}
            font={font2}
            texto={texto2}
            radio={radio2}
            rotar={autoRotar}
            rotacion={rot2}
            posicion={pos2}
            color={usarColorGeneral ? colorGeneral : colorTexto2}
          />
        )}
        {font3 && (
          <TextoExtrusionVertical
            ref={ref3}
            font={font3}
            texto={texto3}
            radio={radio3}
            rotar={autoRotar}
            rotacion={rot3}
            posicion={pos3}
            color={usarColorGeneral ? colorGeneral : colorTexto3}
          />



        )}
{ /* --- Bases: modo global o individual --- */ }
{mostrarBase && !baseIndividual && (
  <BaseAutomatica
    textosRefs={[ref1, ref2, ref3]}
    mostrar={mostrarBase}
    tipoBase={tipoBase}
    color={colorBase}
    offsetY={offsetY}
    onSizeChange={(size) => localStorage.setItem("tamBaseAuto", JSON.stringify(size))}
    onCenterChange={(centros) => setCentrosBase(centros)}
  />
)}

{mostrarBase && baseIndividual && (
  <>
    {/* base para texto1 */}
    {texto.trim() !== "" && (
      <BaseAutomatica
        ref={baseRef1}
        textosRefs={[ref1]}
        mostrar={true}
        tipoBase={"normal"}          // bases individuales siempre 'normal' por simplicidad
        color={colorBase}
        offsetY={offsetY}
        manualPosition={baseOffset1}   // 👈 Aquí aplicas los sliders
        onSizeChange={(size) => {/* opcional: manejar tamaños individuales */}}
        onCenterChange={(centros) => {
          // si quieres, puedes agregar los centros individuales al estado general
          setCentrosBase((prev) => ({ ...prev, ind1: centros }));
        }}
      />
    )}

    {/* base para texto2 */}
    {texto2.trim() !== "" && (
      <BaseAutomatica
        textosRefs={[ref2]}
        ref={baseRef2}
        mostrar={true}
        tipoBase={"normal"}
        color={colorBase}
        offsetY={offsetY}
        manualPosition={baseOffset2}   // 👈 Aquí aplicas los sliders
        onCenterChange={(centros) => setCentrosBase((prev) => ({ ...prev, ind2: centros }))}
      />
    )}

    {/* base para texto3 */}
    {texto3.trim() !== "" && (
      <BaseAutomatica
        textosRefs={[ref3]}
        ref={baseRef3}
        mostrar={true}
        tipoBase={"normal"}
        color={colorBase}
        offsetY={offsetY}
        manualPosition={baseOffset3}   // 👈 Aquí aplicas los sliders
        onCenterChange={(centros) => setCentrosBase((prev) => ({ ...prev, ind3: centros }))}
      />
    )}
  </>
)}




{modeloIzquierda && centrosBase && (
  <primitive
    object={modeloIzquierda}
    position={[
      centrosBase.izquierda[0] + 1.4 + glbTransforms.izquierda.pos.x,
      centrosBase.izquierda[1] + 1 + glbTransforms.izquierda.pos.y,
      centrosBase.izquierda[2] + glbTransforms.izquierda.pos.z,
    ]}
    scale={[150 * glbTransforms.izquierda.scale, 150 * glbTransforms.izquierda.scale, 150 * glbTransforms.izquierda.scale]}
  />
)}

{modeloDerecha && centrosBase && (
  <primitive
    object={modeloDerecha}
    position={[
      centrosBase.derecha[0] - 1.4 + glbTransforms.derecha.pos.x,
      centrosBase.derecha[1] + 1 + glbTransforms.derecha.pos.y,
      centrosBase.derecha[2] + glbTransforms.derecha.pos.z,
    ]}
    scale={[150 * glbTransforms.derecha.scale, 150 * glbTransforms.derecha.scale, 150 * glbTransforms.derecha.scale]}
  />
)}







      </group>
      <OrbitControls />
    </Canvas>
  </div>
);

}

/**
 * BaseAutomatica
 * - Calcula bounding box global de los textos (refs)
 * - Si no hay geometría válida, crea una base por fallback a partir de longitudes de texto
 * - Siempre intenta crear una base (si 'mostrar' es true la muestra, si es false igual genera geometry en memoria)
 */
const BaseAutomatica = forwardRef(function BaseAutomatica({
  textosRefs = [],
  mostrar = true,
  tipoBase = "normal",
  color = "#0066aa",
  onSizeChange,
  onCenterChange,
  offsetY = 0,
  manualPosition = { x: 0, y: -1.4, z: 0 },
}, ref) {
  const baseRef = useRef();
  const [geometry, setGeometry] = useState(null);
  const [offset, setOffset] = useState([0, 0, 0]);

  // Exponer el mesh interno a la ref que venga desde el padre
  useImperativeHandle(ref, () => baseRef.current, []);

  useEffect(() => {
    if (!textosRefs.length) return;

    const globalBox = new THREE.Box3();
    let foundAny = false;

    textosRefs.forEach((r) => {
      const obj = r?.current;
      if (obj) {
        try {
          obj.updateMatrixWorld?.(true);
          const box = new THREE.Box3().setFromObject(obj);
          if (!box.isEmpty()) {
            globalBox.union(box);
            foundAny = true;
          }
        } catch (e) {
          console.warn("error calculando bbox texto:", e);
        }
      }
    });

    if (!foundAny) return;

    const sizeWorld = new THREE.Vector3();
    globalBox.getSize(sizeWorld);
    const centerWorld = new THREE.Vector3();
    globalBox.getCenter(centerWorld);

    // Convertir a coordenadas locales (del primer texto existente)
    const firstRefObj = textosRefs.find((r) => r?.current)?.current;
    let centerLocal = centerWorld.clone();
    let sizeLocal = sizeWorld.clone();

    if (firstRefObj && firstRefObj.parent) {
      firstRefObj.parent.worldToLocal(centerLocal);
      const parentScale = new THREE.Vector3();
      firstRefObj.parent.getWorldScale(parentScale);
      parentScale.x = parentScale.x || 1;
      parentScale.y = parentScale.y || 1;
      parentScale.z = parentScale.z || 1;
      sizeLocal.divide(parentScale);
    }

    const margen = 1.2;
    const ancho = Math.max(sizeLocal.x * margen, 0.1);
    const largoInicial = sizeLocal.z || 1;

    const largo = textosRefs.length === 1 ? 3 : Math.max(largoInicial * margen, 0.1);
    const alto = 0.85;

    let geom;
    const lateralMultiplier = 1.2;
    let offsetX = 0;

    switch (tipoBase) {
      case "izquierda":
        geom = new THREE.BoxGeometry(ancho * lateralMultiplier, alto, largo);
        offsetX = -ancho * (lateralMultiplier - 1) / 2;
        break;
      case "derecha":
        geom = new THREE.BoxGeometry(ancho * lateralMultiplier, alto, largo);
        offsetX = ancho * (lateralMultiplier - 1) / 2;
        break;
      case "ambos":
        geom = new THREE.BoxGeometry(ancho * (lateralMultiplier * 1.2), alto, largo);
        offsetX = 0;
        break;
      default:
        geom = new THREE.BoxGeometry(ancho, alto, largo);
        offsetX = 0;
    }

    setGeometry(geom);

    // posición centrada bajo el texto
    const yFijo = -3.1; // mantenlo o ajusta según tu escena
    const posX = centerLocal.x + offsetX + (manualPosition.x || 0);
    const posY = yFijo + (manualPosition.y || 0);
    const posZ = centerLocal.z + (manualPosition.z || 0);

    setOffset([posX, posY, posZ]);

    const centros = {
      centro: [centerLocal.x, posY + alto / 2, centerLocal.z],
      izquierda: [centerLocal.x - ancho / 2, posY + alto / 2, centerLocal.z],
      derecha: [centerLocal.x + ancho / 2, posY + alto / 2, centerLocal.z],
    };
    onCenterChange?.(centros);
    onSizeChange?.({ ancho, alto, largo });
  }, [textosRefs, tipoBase, offsetY, manualPosition, onCenterChange, onSizeChange]);

  // si aún no hay geometría, no renderizamos nada
  if (!geometry) return null;

  // Renderizamos el mesh y permitimos controlar su visibilidad con `mostrar`
  return (
    <mesh ref={baseRef} position={offset} visible={mostrar}>
      <primitive object={geometry} attach="geometry" />
      <meshStandardMaterial color={color} />
    </mesh>
  );
});

/**
 * AjusteCamaraResponsive
 */
function AjusteCamaraResponsive({ setZoom }) {
  const { camera, size } = useThree();

  useEffect(() => {
    const zoomBase = 80;
    const zoomAjustado =
      size.width < 768 ? zoomBase * 1.4 :
      size.width < 1200 ? zoomBase * 1.1 :
      zoomBase;

    camera.position.set(0, 0, zoomAjustado);
    camera.updateProjectionMatrix();
    setZoom(zoomAjustado);
  }, [size, camera, setZoom]);

  return null;
}
/**
 * TextoExtrusionVertical
 * Ahora con forwardRef + useImperativeHandle para exponer el group (útil para calcular bounding boxes)
 */
const TextoExtrusionVertical = forwardRef(function TextoExtrusionVertical({
  font, texto, radio, rotar, rotacion, posicion, color = "#00ccff"
}, ref) {
  const meshRef = useRef();

  // Guardamos el texto en userData para fallback en BaseAutomatica
  useEffect(() => {
    if (meshRef.current) {
      meshRef.current.userData = meshRef.current.userData || {};
      meshRef.current.userData.text = texto;
    }
  }, [texto]);

  useImperativeHandle(ref, () => {
    // Exponer el group meshRef.current al padre para setFromObject
    return meshRef.current;
  }, []);

  const angle = Math.PI / 3;
  const shapes = useMemo(() => {
    try {
      return font.generateShapes(texto || " ", 3);
    } catch (e) {
      return [];
    }
  }, [font, texto]);

  // Curva arco para extrusión
  const arcCurve = useMemo(() => new THREE.ArcCurve(0, 0, Math.max(radio, 1), 0, angle, false), [radio]);
  const arcPoints = useMemo(() => arcCurve.getPoints(12).map((p) => new THREE.Vector3(0, -p.x, p.y)), [arcCurve]);
  const path = useMemo(() => new THREE.CatmullRomCurve3(arcPoints), [arcPoints]);
  const extrudeSettings = useMemo(() => ({ steps: 12, bevelEnabled: false, extrudePath: path }), [path]);

  const textGeometry = useMemo(() => {
    try {
      const geo = new THREE.ExtrudeGeometry(shapes, extrudeSettings);
      geo.computeBoundingBox();
      geo.center();
      return geo;
    } catch (e) {
      // fallback geom mínimo para que no rompa
      const g = new THREE.BoxGeometry(1, 1, 1);
      g.computeBoundingBox();
      return g;
    }
  }, [shapes, extrudeSettings]);

  useFrame(() => {
    if (rotar && meshRef.current) {
      meshRef.current.rotation.y += 0.005;
    }
  });

  return (
    <group
      ref={meshRef}
      rotation={[rotacion.x, rotacion.y, rotacion.z]}
      position={[posicion.x, posicion.y, posicion.z]}
    >
      <mesh ref={ref} geometry={textGeometry}>
        <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} />
      </mesh>
    </group>
  );
});

// === Estilos ===
const inputStyle = {
  position: "absolute",
  top: 20,
  left: 20,
  zIndex: 10,
  padding: "10px 15px",
  borderRadius: 8,
  border: "none",
  outline: "none",
  background: "#222",
  color: "white",
  fontSize: 18,
};

const selectStyle = {
  position: "absolute",
  top: 20,
  right: 20,
  zIndex: 10,
  padding: 10,
  borderRadius: 8,
  border: "none",
  outline: "none",
  background: "#222",
  color: "white",
  fontSize: 16,
};

const panelGeneral = {
  position: "absolute",
  bottom: 20,
  left: 20,
  zIndex: 10,
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
  maxWidth: 500,
};

const panelZoom = {
  position: "absolute",
  bottom: 20,
  right: 20,
  zIndex: 10,
  color: "white",
  display: "flex",
  flexDirection: "column",
  gap: 8,
  width: 250,
};

const panelBase = {
  position: "absolute",
  top: 80,
  left: 20,
  zIndex: 10,
  background: "#222",
  padding: 10,
  borderRadius: 8,
  boxShadow: "0 0 10px rgba(0,0,0,0.5)",
  width: 260,
  marginTop:"110px"
};

const btn = {
  background: "#00ccff",
  border: "none",
  color: "#111",
  borderRadius: 6,
  padding: "6px 10px",
  cursor: "pointer",
  fontWeight: "bold",
};

const btnAlt = {
  ...btn,
  background: "#0099cc",
};

const btnReset = {
  background: "#ffcc00",
  border: "none",
  color: "#111",
  borderRadius: 6,
  padding: "8px 12px",
  cursor: "pointer",
  fontWeight: "bold",
  alignSelf: "center",
};

const btnMini = {
  background: "#00ccff",
  border: "none",
  color: "#111",
  borderRadius: 6,
  padding: "4px 8px",
  cursor: "pointer",
  fontWeight: "bold",
};

const filaColor = {
  position: "absolute",
  left: 20,
  display: "flex",
  alignItems: "center",
  gap: 10,
  zIndex: 10,
};

const circuloColor = {
  width: 28,
  height: 28,
  borderRadius: "50%",
  border: "2px solid white",
  cursor: "pointer",
};

